import React from "react"
import Select from "react-select"
import { FaTrash } from "react-icons/fa"

const ProductionInputTable = ({
    formData,
    finishedGoodsOptions,
    handleSelectItem,
    handleItemChange,
    removeRow,
    selectStyles,
    editableClass,
    readonlyClass,
    formatSalesValue,
}) => {
    return (
        <div className="overflow-x-auto border border-gray-200 rounded-md">
            <table className="w-full text-sm text-center">
                <thead className="bg-gray-100 text-gray-700">
                    <tr>
                        <th className="px-3 py-3 font-semibold">
                            Item
                        </th>

                        <th className="px-3 py-3 font-semibold">
                            Qty
                        </th>

                        <th className="px-3 py-3 font-semibold">
                            UOM
                        </th>

                        <th className="px-3 py-3 font-semibold">
                            Rate
                        </th>

                        <th className="px-3 py-3 font-semibold">
                            Total
                        </th>

                        <th className="px-3 py-3 text-center font-semibold">
                            Action
                        </th>
                    </tr>
                </thead>

                <tbody>
                    {formData.items.map((item, index) => (
                        <tr
                            key={index}
                            className="border-t border-gray-100"
                        >
                            <td className="px-3 py-2 min-w-[260px] text-left">
                                <Select
                                    options={finishedGoodsOptions}
                                    value={
                                        item.ItemName
                                            ? {
                                                label: `${item.ItemName} (${item.UOM})`,
                                                value: item.ItemName,
                                            }
                                            : null
                                    }
                                    onChange={(selected) =>
                                        handleSelectItem(
                                            selected,
                                            index
                                        )
                                    }
                                    placeholder="Select Item"
                                    styles={{
                                        ...selectStyles,
                                        menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 9999,
                                        }),
                                    }}
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                />
                            </td>

                            <td className="px-3 py-2 w-[150px]">
                                <input
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    value={item.Quantity}
                                    onChange={(e) =>
                                        handleItemChange(
                                            index,
                                            "Quantity",
                                            e.target.value
                                        )
                                    }
                                    className={`${editableClass} text-center`}
                                />
                            </td>

                            <td className="px-3 py-2 w-[125px]">
                                <input
                                    type="text"
                                    value={item.UOM}
                                    readOnly
                                    className={`${readonlyClass} text-center`}
                                />
                            </td>

                            <td className="px-3 py-2 w-[150px]">
                                <input
                                    type="number"
                                    value={formatSalesValue(
                                        item.Rate
                                    )}
                                    readOnly
                                    className={`${readonlyClass} text-center`}
                                />
                            </td>

                            <td className="px-3 py-2 w-[160px]">
                                <input
                                    type="number"
                                    value={parseFloat(item.Total || 0).toFixed(2)}
                                    readOnly
                                    className={`${readonlyClass} text-center`}
                                />
                            </td>

                            <td className="px-3 py-2 text-center">
                                <button
                                    type="button"
                                    onClick={() =>
                                        removeRow(index)
                                    }
                                    disabled={
                                        formData.items.length === 1
                                    }
                                    className="inline-flex items-center justify-center w-9 h-9 rounded-lg border border-red-200 text-red-600 hover:bg-red-50 disabled:opacity-40"
                                >
                                    <FaTrash size={13} />
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default ProductionInputTable